import React, { Component } from "react";
import { Slider } from "antd";

class Revenue extends Component {
	formatVal(value){
		// format tooltip for revenue slider
		// currently set at millions
		if (value >= 1000) {
			let bilVal = value.toString().slice(0,-2).replace(/\B(?=(\d{1})+(?!\d))/g, ".")
			return `$${bilVal}B`;
		} else {
			return `$${value}M`;
		}
	}
	formatQueryRange(value){
		let formattedVal = value.join('<revenue<');
		this.props.buildSearchQuery('revenue', formattedVal);
	}
	render() {
		const marks = {
			10: '$10M',
			2000: '$2B'
		}
		return (
			<section>
				<p className="panel-section-header">
					{this.props.queryTypeSingular}'s Revenue
				</p>
				<div>
					<Slider
						range
						marks={marks}
						step={1}
						min={10}
						max={2000}
						tipFormatter={this.formatVal.bind(this)}
						defaultValue={[0, 2000]}
						onChange={this.formatQueryRange.bind(this)}
					/>
				</div>
			</section>
		);
	}
}

export default Revenue;


// WEBPACK FOOTER //
// ./src/components/Search/PanelLeft/AcquirorsOptions/Revenue/Revenue.js